<div class="mapContent">
    <!-- <app-map fxFlex> </app-map> -->

    <app-source-map></app-source-map>

    <!-- <div id="ctr">
    <app-sequential-search ></app-sequential-search>
</div> -->
</div>

<div class="attributeContent" >
    <div #attributeTable></div>
</div>

<div class="chartContent" >
    <h2 style="text-align: center;">Plan Charts</h2>
    <div class="canva row">
        
        <div class="col-lg-2"><canvas id="MyChart1"></canvas></div>
        <div class="col-lg-2"><canvas id="MyChart2" ></canvas></div>
        <div class="col-lg-2"><canvas id="MyChart3" ></canvas></div>
        <div class="col-lg-2"><canvas id="MyChart4" ></canvas></div>
        <div class="col-lg-2"><canvas id="MyChart5" ></canvas></div>
        <div class="col-lg-2"><canvas id="MyChart6" ></canvas></div>
        <div class="col-lg-2"><canvas id="MyChart7" ></canvas></div>
        <div class="col-lg-2"><canvas id="MyChart8" ></canvas></div>
        <div class="col-lg-2"><canvas id="MyChart9" ></canvas></div>
    </div>
</div>

